import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RetentionModal from '../RetentionModal';
import { actions as fusionActions } from '../../reducers/fusion';

import './PreventionModal.scss';

const COMPONENT_NAME = 'preventionmodal';

/**
 * Componnte para cargarDentro del modal de retencion Repo Down
 * @param {object} info informacion para el modal
 * @param {object} taggingInfoPreventionModal informacion para el modal
 * @param {boolean} forcedDisabled (opcional) flag para establecer si los productItems estan en modo des-habilitado
 * @returns {jsx}
 *
 * @Components {null}
 */
const PreventionModal = ({
  info,
  taggingInfoPreventionModal,
  forcedDisabled,
}) => {
  const preventionGroup = useSelector(
    (state) => state.fusion.preventionProduct
  );
  const {
    productHiredUnique, // producto contratado
    prpvCode,
  } = info;
  const processInfo = info;
  const dispatch = useDispatch();
  const { product, recom: recomHired } = productHiredUnique;
  const { taxonomy } = product;
  const { prodCode } = recomHired;
  if (prpvCode && (taxonomy || prodCode) && prodCode && !preventionGroup) {
    dispatch(
      fusionActions.getPreventionProductBegins({
        recomCode: taxonomy || prodCode,
        promoCode: prpvCode,
      })
    );
  }
  if (!preventionGroup) {
    return null;
  }

  if (preventionGroup) {
    processInfo.productHiredUnique = preventionGroup['fusion prevencion'].aliasProduct;
    processInfo.groupProductHired = preventionGroup['fusion prevencion'];
    processInfo.hiredAliasProduct = 'aliasProduct';
  }

  return (
    <RetentionModal
      info={info}
      taggingInfoRetentionModal={taggingInfoPreventionModal}
      forcedDisabled={forcedDisabled}
      isPrevention={false}
      retentionOffer
    />
  );
};
export default PreventionModal;
